import { render, staticRenderFns } from "./OrderViewActionsSpecAwaitingQuotation.vue?vue&type=template&id=b4f4a91c&"
import script from "./OrderViewActionsSpecAwaitingQuotation.vue?vue&type=script&lang=js&"
export * from "./OrderViewActionsSpecAwaitingQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports